import { EventDataClass, IEventData } from '../data/event/data.js';

export const DEFAULT_PATTERN_ID = 0;

export interface IEventModify {
  id: string;
  bundleToken: string;
  data: IEventData;
  patternId: number;
  isGallery: boolean;
}

export class EventModifyClass implements IEventModify {
  id: string;
  bundleToken: string;
  data: IEventData;
  patternId: number;
  isGallery: boolean;

  constructor(event?: Partial<IEventModify>) {
    this.id = event?.id ?? '';
    this.bundleToken = event?.bundleToken ?? '';
    this.data = event?.data ?? new EventDataClass();
    this.patternId = event?.patternId ?? DEFAULT_PATTERN_ID;
    this.isGallery = event?.isGallery ?? true;
  }
}
